/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDinghyBookingController', BoardDinghyBookingController);

    BoardDinghyBookingController.$inject = ['$state', 'BoardDinghyBooking', 'BoardDinghyBookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'entity', '$stateParams', '$http', 'Principal'];

    function BoardDinghyBookingController($state, BoardDinghyBooking, BoardDinghyBookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, entity, $stateParams, $http, Principal) {

        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.getUser = getUser;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;
        vm.selected = null;
        vm.selectUser = selectUser;
        vm.refresh = refresh;

        loadAll();

        function loadAll () {
            if(entity != null) {
                vm.selected = entity.user.firstName + " " + entity.user.lastName + (entity.nickname ? (' "' + entity.nickname + '"') : (''));
            }
            if (pagingParams.search) {
                BoardDinghyBookingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                BoardDinghyBooking.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    profileId: $stateParams.select
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
                vm.isSaving = false;
            }
            function onError(error) {
                AlertService.error(error.data.message);
                vm.isSaving = false;
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.select = null;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.select = null;
            vm.transition();
        }

        function refresh() {
            vm.isSaving = true;
            loadAll();
        }

        function getUser(val) {
            return $http.get('api/_search/profiles_dinghy/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function selectUser(item, model) {
            vm.select = model.id;
            vm.transition();
        }
    }
})();
